import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import * as moment from 'moment-timezone';
declare var $:any;

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})
export class TransactionComponent {

  public dataListing:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public searchKey1:any='';

  public CurrentUrl:any=this.router.url;
  public backUrl:any= localStorage.getItem('hva_backUrl');
  public userNames:any= localStorage.getItem('hva_usertr_name');

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('hva_login') || "{}"); 
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

  getDetail(page:any){
    this.loading=true;
    var url:any='';
    if(this.CurrentUrl =='/yearly-transaction'){
      url="transaction-list?page="+page+'&filter=Yearly';
    }
    if(this.CurrentUrl =='/monthly-transaction'){
      url="transaction-list?page="+page+'&filter=Monthly';
    }
    if(this.CurrentUrl =='/daily-transaction'){
      url="transaction-list?page="+page+'&filter=Daily';
    }
    if(this.CurrentUrl=='/transaction'){
      url="transaction-list?page="+page; 
    } else if(this.CurrentUrl=='/my-transaction'){
      url="transaction-list?page="+page +"&userId="+localStorage.getItem('hva_usertr_id');
    } else if(this.CurrentUrl =='/withdraw-transaction'){
      url="withdraw-transcation?page="+page;
    } else {
      url="/refund?page="+page;  
    }    
    if(this.searchKey!=''){
      url=url+'&search='+this.searchKey;
    }

    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self =this;      
        this.dataListing=response.data ;
        this.totalCount = response.totalCounts;  
        this.loading=false;
      } else {
        this.dataListing=[];
        this.totalCount = response.totalCounts;  
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  
  reset(){
    this.p=1;
    this.searchKey='';
    this.searchKey1='';
    this.getDetail(this.p);
  }

  redirect(item:any,type:any){
    if(type ==1){
      localStorage.setItem('hva_tr_id',item._id);
      this.router.navigate(['/transaction-detail']);  
    } else {
      localStorage.setItem('hva_tr_id',item._id);
      this.router.navigate(['/transaction-refund-detail']);
  
    }
  }

  refund(id:any){
    this.loading=true;
    var url:any="/payment/refund/"+id;
    this.service.updateApi1({},url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self =this; 
        this.loading=false;
        this.service.successAlert(response.message);
        this.getDetail(1);
      } else {
        this.service.dangerAlert(response.message);
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }
}
